import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { THEME_COLORS } from '@bluplanet/shared';

export interface BottomTabItem {
  label: string;
  icon: ReactNode;
  path: string;
}

interface BottomTabBarProps {
  tabs: BottomTabItem[];
  currentPath: string;
  onNavigate: (path: string) => void;
}

/** TabBar 高度（px）。BuyerLayout 与子页面 safe-area 引用此值，避免被遮。 */
export const BOTTOM_TAB_HEIGHT = 64;

/** 底部手机 Tab 栏（订单/追踪/单证/理赔），选中主色 */
export default function BottomTabBar({ tabs, currentPath, onNavigate }: BottomTabBarProps) {
  return (
    <Box className="buyer-bottom-tabs"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: '100%',
        height: `calc(${BOTTOM_TAB_HEIGHT}px + env(safe-area-inset-bottom, 0px))`,
        backgroundColor: '#FFFFFF',
        borderTop: `1px solid ${THEME_COLORS.border}`,
        display: 'flex',
        alignItems: 'center',
        zIndex: 10,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.04)',
        // 适配 iPhone 安全区（如有底部 Home Indicator 再加 env(safe-area-inset-bottom)）
        paddingBottom: 'env(safe-area-inset-bottom, 0)',
      }}
    >
      {tabs.map((t) => {
        const active = currentPath.startsWith(t.path);
        return (
          <Box
            key={t.path}
            onClick={() => onNavigate(t.path)}
            sx={{
              flex: 1,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '2px',
              cursor: 'pointer',
              color: active ? THEME_COLORS.primary : '#9E9E9E',
              borderTop: active ? `2px solid ${THEME_COLORS.primary}` : '2px solid transparent',
            }}
          >
            {t.icon}
            <Typography
              sx={{
                fontSize: '11px',
                lineHeight: 1,
                color: active ? THEME_COLORS.primary : '#9E9E9E',
                fontWeight: active ? 600 : 400,
              }}
            >
              {t.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
